import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button, Cell, TextField } from "react-md";
import Toggle from "react-toggle";
import {
  AnswerHelp,
  AnswerOptions,
} from "../component/randomized-parameters/VariablesTable";
/* import { ENTITY_TYPE } from 'draft-js-utils';
import { EditorState, Modifier } from 'draft-js';
import LoadingSpinner from '../component/LoadingSpinner'; */
import {
  default as RichTextEditor,
  default as TextEditor,
} from "../component/TextEditor";
import MathParserUtil from "../lib/math-parser";
import VectorAnswerFormula from "../component/vectors/VectorAnswerFormula";
import { AppProperties } from '../common/function';
import VectorVariableOption from "../component/vectors/VectorVariableOption";
export default class Answer extends Component {
  appProperties = AppProperties();
  constructor(props) {
    super(props);
    this.state = {
      altAnswerTextVisible: false,
      altFeedbackTextVisible: false,
      validformula: false,
    };
  }
  static propTypes = {
    onChange: PropTypes.func,
    updateData: PropTypes.func,
  };
  /*
  componentWillMount() {
    this.setState({ pageLoading: true });
    import('react-rte').then(reactRte => {
      //Loading React RTE Module On Demand
      RichTextEditor = reactRte.default; //Getting the Default Export of React RTE.
      this.setState({ pageLoading: false });
    });
  }
*/

  onAnswerChange = (newvalue) => {
    let { onAnswerTextChange } = this.props;

    onAnswerTextChange(newvalue);

    let enteredString = TextEditor.getHTMLStringFromEditorState(newvalue);
    // console.log("enteredString", enteredString);

    let ansFormula = MathParserUtil.getFormulaFromText(enteredString, true);
    console.debug("ansFormula", ansFormula)
    if (
      ansFormula === null ||
      ansFormula === "" ||
      !MathParserUtil.getVariablesFromText(ansFormula)
    ) {
      this.setState({
        validformula: false,
      });
    } else {
      this.setState({
        validformula: true,
      });
    }

    var imgTagCount = enteredString.split("<img ").length - 1;
    if (imgTagCount >= 1) {
      this.setState({
        altAnswerTextVisible: true,
      });
    }
    if (imgTagCount < 1) {
      this.setState({
        altAnswerTextVisible: false,
      });
      //this.onAltAnswerChange('')
    }
    //console.debug('this.props', imgTagCount,this.props,newvalue,enteredString);
  };
  onAltAnswerChange = (newvalue) => {
    //console.debug(newvalue)
    let { onAltAnswerTextChange } = this.props;

    onAltAnswerTextChange(newvalue);
    //console.debug('this.props', this.props);
  };
  onAltFeedbackChange = (newvalue) => {
    //console.debug(newvalue)
    let { onAltFeedbackTextChange } = this.props;

    onAltFeedbackTextChange(newvalue);
    //console.debug('this.props', this.props);
  };
  onFeedbackChange = (newvalue) => {
    let { onFeedbackTextChange } = this.props;
    onFeedbackTextChange(newvalue);
    let enteredString = TextEditor.getHTMLStringFromEditorState(newvalue);
    var imgTagCount = enteredString.split("<img ").length - 1;
    if (imgTagCount >= 1) {
      this.setState({
        altFeedbackTextVisible: true,
      });
    }
    if (imgTagCount < 1) {
      this.setState({
        altFeedbackTextVisible: false,
      });
    }

    //console.debug('this.props', this.props,enteredString);
  };

  //Add Image File End
  render() {
    /*if (this.state.pageLoading) {
      return <LoadingSpinner />;
    }*/
    
    return (
      <Cell size={12} key={this.props.key}>
        <div key={this.props.key}>
          <input
            id={`answer-label-${this.props.index + 1}`}
            type="button"
            style={this.props.answerButton}
            value={this.props.answerText}
          />{" "}
          <br />
          {this.props.questionNonGraded === 0 ? (
            <div style={{ float: "left", width: "30%" }}>
              <div style={{ float: "left", marginTop: "10px" }}>
                <Toggle
                  id="correctansId"
                  defaultChecked={
                    this.props.answerSwitchValue === 0 ? false : true
                  }
                  icons={false}
                  width={230}
                  onChange={this.props.correctAnswerOnChange}
                />
              </div>
              <p style={{ float: "left", marginTop: "12px" }}>
                <label htmlFor="correctansId" style={this.props.correctAnswer}>
                  Correct Answer
                </label>
              </p>
            </div>
          ) : null}
          <br /> <br />
          <br />
          <br />
          { (this.props.questionType === 0 && [70,80].includes(this.props.defaultAnswerType)) ?
            <div>
              <VectorVariableOption
                    style={{ width: "120%", overflowX: "scroll" }}
                    preview={this.state.isQuestionWithPreview}
                    data={this.props.vectorAnswerVariable}
                    onUploadFile={this.getFileContents}
                    onTableRowChange={
                      (value) => {
                        this.props.onVectorAnswerVariableChange(this.props.index, value)
                      }
                    }
                    onAddVectorAnswer={  () => {
                      this.props.onAddVectorAnswer(this.props.index)
                    }}
                    onRemoveVectorAnswer={(variableIndex)=> {
                      this.props.onRemoveVectorAnswer(this.props.index,variableIndex)
                    }}
                    isVectorOption={true}
                    answerDisplayOptions={
                      this.state.answerDisplayOptions
                    }
                    showDecimalOption={this.state.showDecimalOption}
                    className="variable-table"
              />
              </div>
         : this.props.questionType === 3 && this.props.vectorAnswerFormula && ![30, 40, 50, 60].includes(this.props.defaultAnswerType)
          ? (
            <VectorAnswerFormula
              key={this.props.key}
              data={{
                ...this.props.vectorAnswerFormula,
                defaultAnswerType:this.props.defaultAnswerType,
                name: this.props.vectorAnswerFormula.name
                  ? this.props.vectorAnswerFormula.name
                  : `Answer-${this.props.index + 1}`,
              }}
              onValueChange={(value) =>
                this.props.onVectorAnswerChange(this.props.index, value)
              }
            />
          ) : (
            <RichTextEditor
              value={this.props.AnswerValue.value}
              onChange={this.onAnswerChange}
            />
          )}
          <br></br>
          {(this.props.isRandomized || [50, 60].includes(this.props.defaultAnswerType)) ? <AnswerHelp answerType={this.props.defaultAnswerType} key="answer-help" /> : null}
          {this.props.isRandomized && this.state.validformula
            ? [
                <br key="br-tag"></br>,
                <AnswerOptions
                  key="ans-options"
                  options={this.props.answer_display_options}
                  onChange={(value) =>
                    this.props.onAnswerDisplayOptionsChange(
                      this.props.index,
                      value
                    )
                  }
                  questionVectorTableMap={this.props.questionVectorTableMap}
                  answerVariable={
                    this.props?.AnswerValue?.value 
                    ? MathParserUtil.getFormulaFromText(
                        TextEditor.getHTMLStringFromEditorState(this.props.AnswerValue.value), true
                      ) || ""
                    : ""}
                  className="answer-options"
                />,
              ]
            : null}
          <br />
          <div
            style={
              this.state.altAnswerTextVisible
                ? { width: "63%", marginLeft: "5%" }
                : { display: "none" }
            }
          >
            <table>
              <tbody>
                <tr>
                  <td>
                    {" "}
                    <p style={{ fontSize: "medium", color: "#960000" }}>
                      <label htmlFor="altansId">
                        Title and Alternative Text for all Images in{" "}
                        {this.props.answerText}
                      </label>
                    </p>
                  </td>
                  <td>
                    <Button
                      className="nocqcStyle"
                      icon
                      tooltipLabel="Format : Title Text for 1st Image ; Alt text 1st Image ; Title Text for 2nd Image ; Alt text for 2nd Image and so on. Don't use semicolon at the end of the text. Use it only to separate Title Text and Alt."
                    >
                      help
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>

            <TextField
              id="altansId"
              style={{ borderStyle: "ridge" }}
              rows={2}
              value={this.props.AltAnswerValue.value}
              onChange={this.onAltAnswerChange}
              name="altQuestionEditor"
            />
          </div>
          <br />
          <div style={this.props.feedbackVisible ? {} : { display: "none" }}>
            <p
              style={{
                fontSize: "medium",
                marginLeft: "4em",
                color: "#960000",
              }}
            >
              {this.props.feedbackText}
            </p>
            <TextEditor
              value={this.props.FeedbackValue.value}
              onChange={this.onFeedbackChange}
              name="feedbackTextEditor"
            />
            <br />

            <div
              style={
                this.state.altFeedbackTextVisible
                  ? { width: "63%", marginLeft: "5%" }
                  : { display: "none" }
              }
            >
              <table>
                <tbody>
                  <tr>
                    <td>
                      {" "}
                      <p style={{ fontSize: "medium", color: "#960000" }}>
                        <label htmlFor="altfeedId">
                          Title and Alternative Text for all Images in{" "}
                          {this.props.feedbackText}
                        </label>
                      </p>
                    </td>
                    <td>
                      <Button
                        className="nocqcStyle"
                        icon
                        tooltipLabel="Format : Title Text for 1st Image ; Alt text 1st Image ; Title Text for 2nd Image ; Alt text for 2nd Image and so on. Don't use semicolon at the end of the text. Use it only to separate Title Text and Alt."
                      >
                        help
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <TextField
                id="altfeedId"
                style={{ borderStyle: "ridge" }}
                rows={2}
                value={this.props.AltFeedbackValue.value}
                onChange={this.onAltFeedbackChange}
                name="altQuestionEditor"
              />
            </div>
          </div>
          <br />

          {
            (!this.appProperties.enableLTI) ?
            <Button
              flat
              secondary
              swapTheming
              style={this.props.deleteAnswerButton}
              onClick={this.props.answerDelete}
            >
              Delete Answer
            </Button> : " "

          }
        </div>
      </Cell>
    );
  }
}

// https://github.com/sstur/react-rte      Documentation
